import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

import classes from './styles.module.scss';
import closeCross from '../../assets/images/modals/close-cross.svg';
import infoIcon from '../../assets/images/modals/info.svg';
import Button from '../../components/Button';

export default function ResumeParsingTipsModal({ show, handleClose }) {
  const { t } = useTranslation();

  const tipKeys = [
    'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.tip1',
    'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.tip2',
    'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.tip3',
    'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.tip4',
    'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.tip5',
  ];

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className={classes.ResumeParsingTipsModal}
      backdropClassName={classes.backdrop}
      contentClassName={classes.modalContent}
      dialogClassName={classes.dialog}
    >
      <div className={classes.content}>
        <button
          className={classes.closeButton}
          type="button"
          onClick={handleClose}
        >
          <img src={closeCross} alt="Close" />
        </button>
        <img
          width={32}
          height={32}
          className={classes.icon}
          src={infoIcon}
          alt="Icon"
        />
        <h1 className={classes.title}>
          {t(
            'dashboardComponents.Candidates.CandidatesList.AllCandidates.AddCandidate.resumeParsingTips.title'
          )}
        </h1>
        <ul className={classes.tipsList}>
          {tipKeys.map((tipKey) => (
            <li key={tipKey} className={classes.tipItem}>
              {t(tipKey)}
            </li>
          ))}
        </ul>
        <div className={classes.buttonContainer}>
          <Button onClick={handleClose} width={144}>
            {t('common.gotIt')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
